import React from "react";
import { MapTo } from "@adobe/aem-react-editable-components";
import { Title2Styled } from "./Title.styles";
import { TitleProps, TitleMapTo } from "./Title.types";

export const TitleEditConfig: any = {
	emptyLabel: "Alelo - Title Component",
	isEmpty: function (props: TitleProps) {
		return !props || props.text == null || props.text.trim().length === 0;
	},
};

export default function Title(props: TitleProps) {
	const { text, color, backgroundColor } = props;

	return (
		<Title2Styled $backgroundColor={backgroundColor}>
			<h1 className={["alelo-title", `alelo-title--${color}`].join(" ")}>
				{text}
			</h1>
		</Title2Styled>
	);
}

MapTo<TitleMapTo>("alelo/components/content/v1/title")(Title, TitleEditConfig);
